export default __webpack_public_path__ + "static/media/setting.f1587837.svg";